var _defs, _path, _path2, _line, _line2, _line3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _line4, _path14, _path15, _circle, _circle2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _line5, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _ellipse, _ellipse2, _line6, _line7, _path36, _polyline, _path37, _line8, _line9, _path38, _path39, _path40, _line10, _line11, _line12, _line13, _path41, _path42, _path43, _line14, _circle3, _path44, _rect, _rect2, _rect3, _rect4, _path45, _path46, _polygon, _path47, _path48, _path49, _line15, _path50;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-22,.cls-24{fill:#e8f4fa;}.cls-2,.cls-8{fill:#fff;}.cls-18,.cls-3,.cls-6{fill:none;}.cls-3{stroke:#4f4a45;}.cls-11,.cls-14,.cls-15,.cls-22,.cls-23,.cls-3,.cls-6,.cls-7,.cls-8{stroke-linecap:round;}.cls-11,.cls-14,.cls-15,.cls-18,.cls-22,.cls-23,.cls-24,.cls-25,.cls-27,.cls-28,.cls-3,.cls-6,.cls-7,.cls-8{stroke-linejoin:round;}.cls-4,.cls-7{fill:#00b8f0;}.cls-5{fill:#4acfff;}.cls-11,.cls-14,.cls-15,.cls-18,.cls-22,.cls-23,.cls-24,.cls-25,.cls-27,.cls-28,.cls-6,.cls-7,.cls-8{stroke:#45413c;}.cls-11,.cls-9{fill:#ffcebf;}.cls-10{fill:#ffb59e;}.cls-12{fill:#ffdf3d;}.cls-13{fill:#ffef9e;}.cls-14,.cls-17,.cls-25{fill:#adc4d9;}.cls-15,.cls-19{fill:#656769;}.cls-16,.cls-23{fill:#8ca4b8;}.cls-20{fill:#87898c;}.cls-21{fill:#020202;opacity:0.15;}.cls-26,.cls-27{fill:#c0dceb;}.cls-28{fill:#edf2f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "radio-host") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90,50.31a40,40,0,1,0-76.44,16.5H86.44A39.85,39.85,0,0,0,90,50.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.56,66.81a40,40,0,0,0,72.88,0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11,
    y1: 66.81,
    x2: 89,
    y2: 66.81
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6.5,
    y1: 66.81,
    x2: 9,
    y2: 66.81
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 91,
    y1: 66.81,
    x2: 93.5,
    y2: 66.81
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.5,43.5A15.65,15.65,0,0,1,70,59.14v7.67H39V59.14A15.65,15.65,0,0,1,54.5,43.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.5,43.5A15.65,15.65,0,0,1,70,59.14v5.5a15.5,15.5,0,1,0-31,0v-5.5A15.65,15.65,0,0,1,54.5,43.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.5,43.5A15.65,15.65,0,0,1,70,59.14v7.67H39V59.14A15.65,15.65,0,0,1,54.5,43.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M54.5,38.81c-6-1-13.34-1.2-12,5.5.62,3.08,2.08,3.11,12,8.5,9.92-5.39,11.38-5.42,12-8.5C67.84,37.61,60.5,37.81,54.5,38.81Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.5,38.81c-4.72-.79-10.27-1.08-11.77,2.1,1.19,2.81,2.24,3.44,11.77,6.9,9.53-3.46,10.58-4.09,11.77-6.9C64.77,37.73,59.22,38,54.5,38.81Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.68,48.12a28.3,28.3,0,0,1,1.81,10.23"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58,40.81V45a4.79,4.79,0,0,1-.56,2.26l-2.94,5.6-2.94-5.6A4.79,4.79,0,0,1,51,45V40.81Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M58,44.34a13.27,13.27,0,0,1-7,0V40.81h7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58,40.81V45a4.79,4.79,0,0,1-.56,2.26l-2.94,5.6-2.94-5.6A4.79,4.79,0,0,1,51,45V40.81Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.32,48.12a28.3,28.3,0,0,0-1.81,10.23"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.5,72.31H55a2.5,2.5,0,0,1,2.5,2.5v0a2.5,2.5,0,0,1-2.5,2.5H51.5a0,0,0,0,1,0,0v-5A0,0,0,0,1,51.5,72.31Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 45,
    y1: 66.17,
    x2: 45,
    y2: 57.55
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39,61.54v4.59C39,72,43.12,77.6,51.5,77.6v-5a1,1,0,0,0-1-1A5.34,5.34,0,0,1,45,66.13V61.36"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64.5,30.31v-2.5a10,10,0,0,0-20,0v2.5a2,2,0,0,0,0,4h.12a10,10,0,0,0,19.76,0h.12a2,2,0,0,0,0-4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 48.75,
    cy: 34.56,
    r: 1.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 60.25,
    cy: 34.56,
    r: 1.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.5,37.1a4.32,4.32,0,0,1-6,0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M52,31.31a1.63,1.63,0,0,0-3,0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60,31.31a1.63,1.63,0,0,0-3,0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M53.3,15.71c-7.22,0-10.23,5.27-10.23,10.22v4.22c3,0,3-3.61,3-3.61s7.22,1.2,12-2.41c0,0,3,6,7.83,6V25.93c0-6.05-1.28-8.42-7.22-8.42C58.72,17.51,58.11,15.71,53.3,15.71Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M54.5,18.72c4.89,0,9.14,3.13,11.44,7.78v-.57c0-6.05-1.28-8.42-7.22-8.42,0,0-.61-1.8-5.42-1.8-7.22,0-10.23,5.27-10.23,10.22v.57C45.37,21.85,49.62,18.72,54.5,18.72Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.3,15.71c-7.22,0-10.23,5.27-10.23,10.22v4.22c3,0,3-3.61,3-3.61s7.22,1.2,12-2.41c0,0,3,6,7.83,6V25.93c0-6.05-1.28-8.42-7.22-8.42C58.72,17.51,58.11,15.71,53.3,15.71Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.17,33.81H47.91a2.45,2.45,0,0,1-2.41-2.46v-2a1,1,0,0,1,1-1h6.08a1.2,1.2,0,0,1,1.19,1.34l-.21,1.93A2.46,2.46,0,0,1,51.17,33.81Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.83,33.81h3.26a2.45,2.45,0,0,0,2.41-2.46v-2a1,1,0,0,0-1-1H56.42a1.2,1.2,0,0,0-1.19,1.34l.21,1.93A2.46,2.46,0,0,0,57.83,33.81Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 53.7,
    y1: 30.31,
    x2: 55.3,
    y2: 30.31
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M54.5,10.81c-6.67,0-13.5,4.72-13.5,15.5h2c0-9.58,5-13,11.5-13.5,6.5.5,11.5,3.92,11.5,13.5h2C68,15.53,61.17,10.82,54.5,10.81Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M40.5,26.31h3a1,1,0,0,1,1,1v8.5a1,1,0,0,1-1,1h-3a0,0,0,0,1,0,0V26.31A0,0,0,0,1,40.5,26.31Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M40.5,36.81c-2.21,0-4-2.35-4-5.25s1.79-5.25,4-5.25Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M36.5,31.56a8.12,8.12,0,0,0,.07,1c.36-2.42,2-4.25,3.93-4.25v-2C38.29,26.31,36.5,28.66,36.5,31.56Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M40.5,36.81c-2.21,0-4-2.35-4-5.25s1.79-5.25,4-5.25Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M64.5,26.31h3a1,1,0,0,1,1,1v8.5a1,1,0,0,1-1,1h-3a0,0,0,0,1,0,0V26.31A0,0,0,0,1,64.5,26.31Z",
    transform: "translate(133 63.12) rotate(180)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M68.5,36.81c2.21,0,4-2.35,4-5.25s-1.79-5.25-4-5.25Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M72.5,31.56a8.12,8.12,0,0,1-.07,1c-.36-2.42-2-4.25-3.93-4.25v-2C70.71,26.31,72.5,28.66,72.5,31.56Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M68.5,36.81c2.21,0,4-2.35,4-5.25s-1.79-5.25-4-5.25Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M61.45,11.63a13.42,13.42,0,0,0-13.9,0,1.81,1.81,0,0,0,1.9,3.07,9.75,9.75,0,0,1,10.1,0,1.81,1.81,0,0,0,1.9-3.07Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M54.5,11.31c2.8,0,6.88,1.23,7.6,2.66a1.8,1.8,0,0,0-.65-2.34,13.42,13.42,0,0,0-13.9,0A1.8,1.8,0,0,0,46.9,14C47.62,12.54,51.69,11.31,54.5,11.31Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.45,11.63a13.42,13.42,0,0,0-13.9,0,1.81,1.81,0,0,0,1.9,3.07,9.75,9.75,0,0,1,10.1,0,1.81,1.81,0,0,0,1.9-3.07Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 21.8,
    cy: 75.31,
    rx: 15,
    ry: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 65.3,
    cy: 78.31,
    rx: 19.5,
    ry: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 64.34,
    y1: 58.16,
    x2: 64.34,
    y2: 57.55
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 64.34,
    y1: 66.77,
    x2: 64.34,
    y2: 57.55
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M38.13,45.64,20.84,49.19a1,1,0,0,1-1.18-.78l-1.05-5.12a1,1,0,0,1,.14-.75,1.06,1.06,0,0,1,.64-.43l17.29-3.55Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "25.23 54.29 26 53.54 26 50.07"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M23.66,58.38l-1.92-1.45,1.81-2.4A1.2,1.2,0,1,1,25.47,56Z"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.62,
    y1: 55.94,
    x2: 7.18,
    y2: 49.93
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.02,
    y1: 60.16,
    x2: 6.58,
    y2: 54.14
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.41,42.12l-.73-3.56L19.39,42.11a1.06,1.06,0,0,0-.64.43,1,1,0,0,0-.14.75l.53,2.58Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.13,45.64,20.84,49.19a1,1,0,0,1-1.18-.78l-1.05-5.12a1,1,0,0,1,.14-.75,1.06,1.06,0,0,1,.64-.43l17.29-3.55Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.38,38.25h1.41a1,1,0,0,1,1,1v5.22a1,1,0,0,1-1,1H37.38a0,0,0,0,1,0,0V38.25A0,0,0,0,1,37.38,38.25Z",
    transform: "translate(-7.64 8.62) rotate(-11.61)"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 35.29,
    y1: 43.76,
    x2: 35.77,
    y2: 46.12
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 34.32,
    y1: 39.05,
    x2: 34.8,
    y2: 41.41
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 32.93,
    y1: 44.25,
    x2: 33.41,
    y2: 46.6
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 31.96,
    y1: 39.53,
    x2: 32.45,
    y2: 41.89
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.11,50,23.94,39.34l3.23-1.45A1,1,0,0,1,28.55,39l-1.17,5.14,3.1,4.25A1,1,0,0,1,29.66,50Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23.94,39.34,20,39a1,1,0,0,0-.88,1.62l3.56,4.53-1.58,5.16a1,1,0,0,0,1.35,1.21L26.11,50"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M18.65,43.49l-.3.06a2.71,2.71,0,0,0,1.09,5.31l.3-.06Z"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 22.67,
    y1: 45.13,
    x2: 27.38,
    y2: 44.16
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 21.62,
    cy: 58.35,
    r: 3.01
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M22.82,58.35a1.21,1.21,0,1,1-1.2-1.2A1.2,1.2,0,0,1,22.82,58.35Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 9.5,
    y: 71.81,
    width: 24,
    height: 2.5,
    rx: 1.25,
    ry: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 10.5,
    y: 69.31,
    width: 24,
    height: 2.5,
    rx: 1.25,
    ry: 1.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 9.5,
    y: 66.81,
    width: 24,
    height: 2.5,
    rx: 1.25,
    ry: 1.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 10.5,
    y: 64.31,
    width: 24,
    height: 2.5,
    rx: 1.25,
    ry: 1.25
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M59.9,74.81H57.49l5.75-17.67a1.2,1.2,0,0,1,1.14-.83h1.53"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M83.36,74.81H59.9l6-18.5H87.73a1.19,1.19,0,0,1,1,.5,1.17,1.17,0,0,1,.17,1.07Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "81.78 56.31 65.91 56.31 59.9 74.81 63.13 74.81 81.78 56.31"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M83.36,74.81H59v3H81C82.27,77.82,83.36,77,83.36,74.81Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M59,74.81H47c0,2.09,1,3,2.37,3H59Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M76.55,64.61a1.36,1.36,0,0,1,.64-1.13,1.39,1.39,0,0,0-1.08-.59c-.46,0-.9.28-1.13.28s-.6-.27-1-.26a1.45,1.45,0,0,0-1.22.74,3.11,3.11,0,0,0,.37,3c.25.36.55.76.94.75s.51-.25,1-.25.58.25,1,.24.66-.37.91-.73a3.51,3.51,0,0,0,.41-.84A1.3,1.3,0,0,1,76.55,64.61Z"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 75.54,
    y1: 61.36,
    x2: 76.08,
    y2: 60.82
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M83.36,74.81H59.9l6-18.5H87.73a1.19,1.19,0,0,1,1,.5,1.17,1.17,0,0,1,.17,1.07Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9db2602e2a095709dcc6f820ca2c86b8.svg";
export { ForwardRef as ReactComponent };